import { createHtmlElement, ElementStyle } from './create-html-element';
import { createPopupModalHeaderElement } from './create-popup-modal-header-element';
import { createPopupModalContentElement } from './create-popup-modal-content-element';

export const createPopupModalElement = (url: string, heading = '') => {
  const headerElement = createPopupModalHeaderElement(heading);
  const contentElement = createPopupModalContentElement(url);

  const modalStyles: ElementStyle[] = [
    { property: 'position', value: 'relative' },
    { property: 'width', value: '400px' },
    { property: 'min-width', value: '300px' },
    { property: 'height', value: '600px' },
    { property: 'background', value: '#fff' },
    { property: 'overflow', value: 'hidden' },
    { property: 'border', value: '2px solid #7F7E7D' },
    { property: 'border-radius', value: '5px' },
    { property: 'box-shadow', value: '0 2px 20px 4px rgba(0, 0, 0, 0.56)' },
  ];
  const popupModalElement = createHtmlElement('div', modalStyles);
  popupModalElement.appendChild(headerElement);
  popupModalElement.appendChild(contentElement);
  return popupModalElement;
};
